export const PAYMENT_ACTIONS = {
  THREE_D_SECURE: 'three_d_secure',
  PAYPAL: 'paypal',
  BLIK: 'blik',
  PIX: 'pix',
  IDEAL: 'ideal',
  DANA: 'dana',
  GCASH: 'gcash',
  OX: 'ox',
  REDIRECT: 'redirect',
  VERIFY_RESERVATION: 'verify_reservation',
  VERIFY_AMENDMENT: 'verify_amendment',
} as const

export type PaymentActionValue = (typeof PAYMENT_ACTIONS)[keyof typeof PAYMENT_ACTIONS]
